import moment from "moment";
export default {
  checkFrom7DayStrict(event, dateFrom, dateTo) {
    try {
      if (event !== undefined) {
        const b = moment(dateFrom);
        const a = moment(dateTo);

        const diff = a.diff(b, "days");

        if (diff >= 7) {
          const date = moment(dateFrom)
            .add(6, "days")
            .format("YYYY-MM-DD");

          return date; // Return and pass value to DateFrom Variable.
        }else{
          return dateTo;
        }
      }
    } catch (error) {
      throw error;
    }
  },
  checkTo7DayStrict(event, dateFrom, dateTo) {
    try {
      if (event !== undefined) {
        const b = moment(dateFrom);
        const a = moment(dateTo);

        const diff = a.diff(b, "days");

        if (diff >= 7) {
          const date = moment(dateTo)
            .subtract(6, "days")
            .format("YYYY-MM-DD");

          return date; // Return and pass value to DateTo Variable.
        }else{
          return dateFrom;
        }
      }
    } catch (error) {
      throw error;
    }
  },
};
